import { normalizeMethod, reduceQueryParams } from '../../../libs/http.js';
import { Raw, objectToString } from '../../../libs/php.js';
/**
 * php/guzzle
 */
export const phpGuzzle = {
    target: 'php',
    client: 'guzzle',
    title: 'Guzzle',
    generate(request, configuration) {
        if (!request) {
            return '';
        }
        const options = {};
        const method = normalizeMethod(request.method);
        const url = request.url || '';
        // Handle headers
        if (request.headers && Array.isArray(request.headers) && request.headers.length > 0) {
            const headers = {};
            request.headers.forEach((header) => {
                if (headers[header.name] === undefined) {
                    headers[header.name] = header.value;
                }
                else if (Array.isArray(headers[header.name])) {
                    headers[header.name].push(header.value);
                }
                else {
                    headers[header.name] = [headers[header.name], header.value];
                }
            });
            options.headers = headers;
        }
        // Handle query parameters
        if (request.queryString && request.queryString.length > 0) {
            options.query = reduceQueryParams(request.queryString);
        }
        // Handle cookies
        if (request.cookies && request.cookies.length > 0) {
            const cookies = {};
            request.cookies.forEach((cookie) => {
                cookies[cookie.name] = cookie.value;
            });
            options.cookies = cookies;
        }
        // Handle authentication
        if (configuration?.auth?.username && configuration.auth.password) {
            options.auth = [configuration.auth.username, configuration.auth.password];
        }
        // Handle request body
        if (request.postData) {
            if (request.postData.mimeType === 'application/json') {
                try {
                    options.json = JSON.parse(request.postData.text || '{}');
                }
                catch (_e) {
                    // If JSON parsing fails, use the raw text
                    options.body = request.postData.text;
                }
            }
            else if (request.postData.mimeType === 'multipart/form-data') {
                if (request.postData.params) {
                    options.multipart = request.postData.params.map((param) => {
                        const part = {
                            name: param.name,
                            contents: param.fileName ? new Raw(`fopen('${param.fileName}', 'rb')`) : param.value || '',
                        };
                        if (param.contentType) {
                            part.headers = { 'Content-Type': param.contentType };
                        }
                        return part;
                    });
                }
                else if (request.postData.text) {
                    try {
                        options.form_params = JSON.parse(request.postData.text);
                    }
                    catch (_e) {
                        options.body = request.postData.text;
                    }
                }
            }
            else if (request.postData.mimeType === 'application/x-www-form-urlencoded') {
                if (request.postData.params) {
                    const formParams = {};
                    request.postData.params.forEach((param) => {
                        formParams[param.name] = param.value || '';
                    });
                    options.form_params = formParams;
                }
            }
            else {
                // For other mime types (like application/octet-stream), use the raw body
                options.body = request.postData.text;
            }
        }
        // Handle compressed responses
        if (request.headers &&
            Array.isArray(request.headers) &&
            request.headers.some((h) => h.name === 'Accept-Encoding' && h.value.includes('gzip'))) {
            options.decode_content = true;
        }
        // Generate the PHP code
        let code = '$client = new GuzzleHttp\\Client();\n\n';
        if (Object.keys(options).length > 0) {
            // Format the options array with proper indentation
            const formattedOptions = objectToString(options);
            code += `$response = $client->request('${method}', '${url}', ${formattedOptions});`;
        }
        else {
            code += `$response = $client->request('${method}', '${url}');`;
        }
        return code;
    },
};
